import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    transactionType: [],
    salesTransactionType: [],
    inventoryTransactionType: []
};

const transactionTypeSlice = createSlice({
    name: "transactionType",
    initialState,
    reducers: {
        setTransactionType: (state, action) => {
            state.transactionType = action.payload;
        },
        setSalesTransactionType: (state, action) => {
            state.salesTransactionType = action.payload;
        },
        setInventoryTransactionType: (state, action) => {
            state.inventoryTransactionType = action.payload;
        }
    }
});

// 🟢 Exporting Actions
export const { setTransactionType, setSalesTransactionType, setInventoryTransactionType } = transactionTypeSlice.actions;

// 🔵 Selectors (Getters)
export const selectTransactionType = (state) => state.transactionType.transactionType;
export const selectSalesTransactionType = (state) => state.transactionType.salesTransactionType;
export const selectInventoryTransactionType = (state) => state.transactionType.inventoryTransactionType;

export const getTransactionByName = (state, type, name) => {
    console.log("name",name)
    let transactions = [];
    if (type === "transactionType") {
        transactions = selectTransactionType(state);
    } else if (type === "salesTransactionType") {
        transactions = selectSalesTransactionType(state);
    } else if (type === "inventoryTransactionType") {
        transactions = selectInventoryTransactionType(state);
    }

    console.log(transactions,transactions.find((item) => item.TransactionType === name),"kya he")
    return transactions.find((item) => item.TransactionType === name) || null;
};

// 🟣 Reducer Export
export default transactionTypeSlice.reducer;
